import { AxiosInstance } from 'axios'
import { RequestError } from '../types/error'
import { MessageUserChat, ResponseMessageUser, PostFavoriteMessage, GetFavoriteMessages, DeleteResponse } from '@/types/internalChatAxios'
//import { FavoriteMessage } from '@/types/itemsMessages'
import { useChatStore } from '@/stores/chat'
type PayloadSearchMessage = {
    text: string,
    offset: number,
}
export interface UserServiceInterface {
    findMessage(userId:number, page?:string): Promise<MessageUserChat>;
    fetchFavorite(userId: number): Promise<GetFavoriteMessages>;
    saveFavorite(userId: number, messageId: number): Promise<PostFavoriteMessage>;
    removeFavorite (userId: number, messageId: number): Promise<DeleteResponse>;
    searchMessage(userId: number, payload: PayloadSearchMessage): Promise<MessageUserChat>;
}

function UserService (httpClient: AxiosInstance): UserServiceInterface {
  async function findMessage (userId:number, offset:string = ''): Promise<MessageUserChat> {
    const chatStore = useChatStore()
    const response = await httpClient.get<ResponseMessageUser>(`/internal-chat/user/${userId}/messages${offset}`, chatStore.config)
    let errors: RequestError | null = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }
    return {
      data: response.data,
      errors
    }
  }

  async function fetchFavorite (userId: number): Promise<GetFavoriteMessages> {
    const chatStore = useChatStore()
    const response = await httpClient.get(`/internal-chat/user/${userId}/messages/favorite`, chatStore.config)
    let errors: RequestError | null = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }
    return {
      data: response.data.data,
      errors
    }
  }

  async function searchMessage (userId: number, payload: PayloadSearchMessage): Promise<MessageUserChat> {
    const chatStore = useChatStore()
    const config = {
        params: {
            ...payload
        },
        ...chatStore.config
    }
    const response = await httpClient.get(`/internal-chat/user/${userId}/messages/search`, config )
    let errors: RequestError | null = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }

    return {
      data: response.data,
      errors
    }
  }

  async function saveFavorite( userId: number, messageId: number): Promise<PostFavoriteMessage> {
    const chatStore = useChatStore()
    const payload = { message_internal_id: messageId }
    const response = await httpClient.post(`/internal-chat/user/${userId}/messages/favorite`, payload, chatStore.config)
    let errors: RequestError | null = null

    if (!response.data) {
      errors = {
        status: response.request.status,
        statusText: response.request.statusText
      }
    }
    return {
      data: response.data.data,
      errors
    }
  }

  async function removeFavorite (userId: number, messageId: number): Promise<DeleteResponse> {
    const chatStore = useChatStore()

    const response = await httpClient.delete<null>(`/internal-chat/user/${userId}/messages/favorite/${messageId}`, chatStore.config)

    let errors: RequestError | null = null

    if (response.request.status >= 400) {
        errors = {
            status: response.request.status,
            statusText: response.request.statusText
          }
    }
    return {
        data: response.data,
        errors
    }
  }
  return {
    findMessage,
    fetchFavorite,
    saveFavorite,
    removeFavorite,
    searchMessage
  }
}

export default UserService
